import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import { List, Typography, withStyles } from 'material-ui';
import { translate } from 'react-i18next';
import { checkAuthorities, navigateToFirstAllowedUrl } from './menudataprovider';
import DynIcon from '../Utils/DynIcon';

const styles = theme => ({});

/**
 * Componente de navegacion que muestra los links con sus iconos y la pagina activa.
 */
class SideBarMenu extends React.Component {
    constructor(props) {
        super(props);
        this.menudataProvider = this.props.menudataProvider;
    }

    getMenuClassForActivePage(currentPage, item) {
        if (item.enabled) {
            return currentPage.indexOf(item.href) !== -1 ? 'cmsStyleMenuActive' : '';
        }
        else {
            return 'cmsStyleButtonDisabled';
        }
    }

    navigateToPage = (item, event) => {
        if (!item.enabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }
        if (item.isHome) {
            navigateToFirstAllowedUrl();
        } else {
            window.location.href = item.href;
        }
    }

    render() {
        let { user, classes, t, menudataProvider } = this.props;
        if (!menudataProvider) {
            menudataProvider = [];
        }
        if (!user) {
            user = { authorities: [] };
        }
        let currentpage = '/' + this.props.currentpage;
        //en el unico caso que la home tiene 2 alias.
        //OLYB2B-438
        const uppercasedauth = user.authorities.map(s => s.toUpperCase());

        menudataProvider = menudataProvider.filter(item => { return item.enabled; });

        if (currentpage === '/#/') {
            currentpage = '/#/search';
        }
        return (
            <List>
                {menudataProvider.map((item, index) => {
                    let hasAccess = checkAuthorities(uppercasedauth, item.regExp);
                    let menuActiveClass;
                    let labeltranslated;
                    if (hasAccess) {
                        menuActiveClass = this.getMenuClassForActivePage(currentpage, item);
                        labeltranslated = t(item.label);
                    }
                    return hasAccess ? (
                        <ListItem
                            key={index}
                            button
                            alt={labeltranslated}
                            title={labeltranslated}
                            className={'cmsStyleMenu ' + menuActiveClass}
                            onClick={(e) => {
                                this.navigateToPage(item, e);
                            }}
                        >
                            <ListItemIcon><DynIcon icon={item.icon} style={{
                                color: 'inherit',
                                fontWeight: 300
                            }} /></ListItemIcon>
                            <ListItemText
                                disableTypography
                                className="MenuLateralButton"
                                primary={
                                    <Typography type="body2" className={classes.styleButton}>
                                        {labeltranslated}
                                    </Typography>
                                }
                            />
                        </ListItem>
                    ) : (
                        ''
                    );
                })}
            </List>
        );
    }
}

export default translate('translations')(withStyles(styles)(SideBarMenu));


// WEBPACK FOOTER //
// ./src/components/SideBar/SideBarMenu.js